<template>
  <div id="page">
    <div class="container">
      <div class="row width_full mb_20">
        <div class="col_12">
          <div class="common_title">
            <h2>{{ pageTitle }}</h2>
          </div>
          <div class="row">
            <div class="col_4">
              <div :class="['form-group', {'has_error': errorFor('name')}]">
                <label>Name</label>
                <input type="text" class="form_global" placeholder="Page Title" v-model="form.name">
                <template v-if="errors && errors.name">
                  <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
                </template>
              </div>
            </div>


            <div class="col_4">
              <div :class="['form-group', {'has_error': errorFor('parent')}]">
                <label>Parent Page</label>
                <select  class="form_global" v-model="form.parent">
                  <option value="">Parent Page</option>
                  <option v-for="page in pages" :key="'page'+page.id" :value="page.id">{{page.name}}</option>
                </select>
                <template v-if="errors && errors.parent">
                  <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.parent" :key="'error_status_'+errorIndex">{{error}}</small>
                </template>
              </div>
            </div>
            <div class="col_4">
              <div :class="['form-group']">
                <label>Status</label>
                <select  class="form_global" v-model="form.status">
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col_12">
              <div :class="['form-group', {'has_error': errorFor('description')}]">
                <label>Description</label>
                <text-editor v-model:text="form['description']" :id="'description'" :height="500"></text-editor>
                <template v-if="errors && errors.description">
                  <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.description" :key="'error_status_'+errorIndex">{{error}}</small>
                </template>
              </div>
            </div>
          </div>
          <div class="d_flex_end">
            <button class="btn btn_success" @click="submitForm()">Save</button>
          </div>
        </div>

      </div>
      <div class="row width_full mt_20 pt_20 mb_20 pb_20" v-if="$route.name === 'page_edit'">
        <div class="col_12">
          <div class="d_flex_btwn">
            <h2>Additional Contents</h2>
            <button class="btn btn_common" @click.prevent="addContent">Add Content</button>
          </div>
        </div>
        <div class="col_12">
<!--          <div class="form-group">-->
<!--            <div v-if="showProgressbar" id="show_video_upload_progress"><span></span></div>-->
<!--            <div v-if="dropzonError" class="text_danger">{{dropzonError}}</div>-->

<!--          </div>-->

<!--          <div class="progress_wrap" v-if="showProgressbar">-->
<!--            <div class="meter">-->
<!--              <span :style="{ 'width': + uploadProgress + '%' } "><span class="progress"></span></span>-->
<!--              <div class="percent">{{ uploadProgress }}%</div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <vue-dropzone class="create_images_drag" id="upload_dropzone" ref="upload_dropzone" :options="dropzoneOptions"-->
<!--                        @vdropzone-total-upload-progress="dropzoneUploadProgress"-->
<!--                        @vdropzone-error="dropzoneFileAdded"-->
<!--                        @vdropzone-success="dropzoneSuccess"-->
<!--                        @vdropzone-complete="dropzoneComplete"-->
<!--                        :useCustomSlot="true">-->
<!--          </vue-dropzone>-->
        </div>
        <div class="col_12 mt_15">
          <div class="customer_content">
            <table-component
                :columns="columns"
                :rows="contents"
                :header="true"
                :centralized="true"
                :sortable="sortable"
                :pagination="pagination"
                :searchShowStatus="false"
                :perPageShowStatus="false"
                @sorting="sorting"
                @pageChanged="pageChanged">
              <template v-slot:file="{ row }">
                <a v-if="row.file" class="color_blue item_size_delete cursor_pointer" :href="row.file"   target="_blank" download>
                  {{ fileNameSlice(row.file) }}
                </a>
              </template>
              <template v-slot:action="{ row }">
                <span @click.prevent="editContent(row)" class="btn btn_success mr_10 cursor_pointer"> Edit</span>
                <span class="ml_10 btn btn_danger cursor_pointer" @click.prevent="deleteRecord(row)">Delete</span>
              </template>
            </table-component>
          </div>
        </div>
      </div>

      <user-content-template></user-content-template>

      <scheduler-caldander v-if="$route.params.id === '25'"></scheduler-caldander>
    </div>

    <modal-component
        v-if="showModal"
        :modal-size="'custom_modal_1200p'"
        :header-classes="'display_table white_bg no_border pa15 pb_0'"
        :content-classes="'pl_15 pr_15'"
        @closeModal="closeModal"
    >
      <template #header>
        <span class="modal_header_title">{{ modalForm && modalForm.id ? "Edit: "+modalForm.name : "Add Content"}}</span>
      </template>
      <template #content>
        <div class="row">
          <div class="col_5">
            <div :class="['form-group', {'has_error': errorFor('name')}]">
              <label class="required">Title</label>
              <input type="text" class="form_global" placeholder="Title" v-model="modalForm.name">
              <template v-if="errors && errors.name">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>

          <div class="col_3">
            <div :class="['form-group']">
              <label>Status</label>
              <select  class="form_global" v-model="modalForm.status">
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>

          <div class="col_4">
            <div :class="['form-group', {'has_error': errorFor('file')}]">
              <label>{{ getLabelName() }}</label>
              <input type="file" class="form_global" ref="imageInput" @input="onFileChange($event, 'file')">
              <template v-if="errors && errors.file">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.file" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div  class="width_full" v-if="modalForm.file">
              <div class="p_relative">
                <span v-if="imageMims.includes(modalForm.file_type)">
                  <img :src="modalForm.file" alt="" width="100">
                </span>
                <span v-else>
                  {{getTitle(modalForm.file)}}
                </span>
                <div class="cross_ic" @click="deleteContentFile(modalForm.id, 'file')"> <i class='bx bx-x'></i> </div>
              </div>
            </div>
          </div>

          <div class="col_8">
            <div class="form-group">
            <label>video  </label>
              <div class="create_images_area">
                <div v-if="showProgressbar" id="show_video_upload_progress"><span></span></div>
              <div v-if="dropzonError" class="text_danger">{{dropzonError}}</div>
              <vue-dropzone class="create_images_drag" id="upload_dropzone" ref="upload_dropzone" :options="dropzoneOptions"
                            @vdropzone-total-upload-progress="dropzoneUploadProgress"
                            @vdropzone-success="dropzoneSuccess"
                            @vdropzone-complete="dropzoneComplete"
                            @vdropzone-removed-file="removeDropzon"
                            @vdropzone-error="dropzoneError"
                            :useCustomSlot="true">
              </vue-dropzone>
              </div>
            </div>
          </div>
          <div class="col_4" v-if="tempVideo">
            <div class="display_inline d_flex_start p_relative mt_20" >
              <video class="width_full" controls autoplay muted>
                <source :src="tempVideo" type="video/mp4">
                <source :src="tempVideo" type="video/wmv">
                <source :src="tempVideo" type="video/WebM">
                Your browser does not support HTML5 video.
              </video>
              <span class="close_icon p_absolute" style="cursor: pointer;color: red;" @click="removeVideo(tempVideo)"></span>
            </div>
          </div>
          <div class="col_12">
            <div :class="['form-group', {'has_error': errorFor('description')}]">
              <label>Description</label>
              <text-editor v-model:text="modalForm['description']" :id="'description2'"></text-editor>
              <template v-if="errors && errors.description">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.description" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_12">
            <div class="d_flex_end">
              <button class="btn btn_common" @click.prevent="submitContentForm">save <i v-if="loading" class="fas fa-circle-notch fa-spin ml_5"></i></button>
            </div>
          </div>
        </div>
      </template>
    </modal-component>
  </div>
</template>

<script>
import TextEditor from "../../components/shared/TextEditor";
import ModalComponent from "../../components/shared/ModalComponent";
import TableComponent from "../../components/shared/TableComponent";
import SchedulerCaldander from "../../components/SchedulerCalander";
import vueDropzone from 'vue2-dropzone-vue3'

import 'dropzone/dist/dropzone.css'
import UserContentTemplate from "./shared/UserContentTemplate";

export default {
  name: "Form",
  components: {UserContentTemplate,vueDropzone, SchedulerCaldander, TableComponent, ModalComponent, TextEditor},
  data(){
    return {
      pages: [],
      imageMims: ['jpeg', 'webp', 'png', 'jpg', 'gif', 'JPG', 'JPEG'],
      dropzonError: '',
      isNewVideoUploaded: false,
      dropzoneOptions: {
        url: process.env.VUE_APP_API_BASE_URL + '/temp-file-upload',
        addRemoveLinks: true,
        uploadMultiple: false,
        disablePreviews: false,
        createImageThumbnails: true,
        allowMultiple: false,
        chunking: true,
        forceChunking: true,
        chunkSize: 20000000,
        maxFiles: 1,
        init: function() {
          this.on('uploadprogress', function (file, progress) {
            window.$("#show_video_upload_progress span").html(Math.round(progress)+"%")
            window.$("#show_video_upload_progress span").css({width:progress+'%'})
          });
        },
        maxFilesize: 5120,
        thumbnailHeight: 120,
        timeout: 9999990000,
        acceptedFiles: "video/mp4,video/x-m4v,video/*,audio/mpeg",
        headers: {
          "Authorization": `Bearer `+ JSON.parse(localStorage.getItem('admin')).token
        }
      },
      form:{
        name: '',
        description: '',
        parent: '',
        page_type: this.$route.params.type,
        status: 1,
      },
      progress: null,
      pageTitle: 'Add New Page',
      contents: [],
      showModal:false,
      newForm: false,
      modalForm:{
        name: '',
        description: '',
        status: 1,
        page_id: this.$route.params.id,
        file: '',
        video: '',
      },
      tempVideo: '',
      sort: '1',
      sortable: {
        order: 'id',
        sort: 'desc'
      },
      filter: {
        status: '',
        per_page: 10
      },
      columns: [
        {
          label: "Name",
          field: "name",
          sortable: true
        },

        {
          label: "File",
          field: "file",
          sortable: false,
          slot: true,
        },
        {
          label: "Action",
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
      uploadProgress: 0,
      showProgressbar: false,
      showUploadError: false,
      showUploadErrorMsg: null,
      disabled: false,
      pagination: null,
      thumbsLabelPages: [22, 23, 21],
      queryParams: {
        page: 1,
        per_page: 10,
        search: '',
        search_columns: 'name',
        sort: '',
        sort_order: '',
        page_type: this.$route.params.type,
        page_id:this.$route.params.id
      },
    }
  },
  watch: {
    queryParams: {
      deep: true,
      handler() {
        this.loadContents()
      }
    },
  },
  created() {
    if(this.$route.name === 'page_edit') {
      this.pageTitle = "Edit Page"
      this.loadCurrentPage()
      this.loadContents()
    }
    this.loadPages()
  },
  methods:{
    removeDropzon(){
       this.removeVideo(this.tempVideo)
    },
    dropzoneError(file, message){
      this.dropzonError = message
    },
    dropzoneUploadProgress(){
      this.showProgressbar = true;
    },
    dropzoneSuccess(file, response){
      let that = this;
      that.modalForm.video = ''
      that.tempVideo = ''
      that.isNewVideoUploaded = true
      setTimeout(() => {
        that.modalForm.video = response.draft;
        that.tempVideo = response.url;
      }, 200);
    },
    dropzoneComplete(response){
      if(response.status == 'success' && this.uploadProgress == 100){
        this.disabled = false
      }
    },

    removeVideo(file){
      this.dropzonError = ''
      file = file.split('storage/')
      this.axios.post('/temp-file-delete/', {draft:file[1], model:'content' }).then((response) => {
        this.showProgressbar = false
        if(response.data.deleted){
          this.tempVideo = ''
          this.modalForm.video = ''
          this.isNewVideoUploaded = false
        }
      })
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
    },
    fileNameSlice(text){
      if(text && typeof text === 'string') {
        let row = text.split('/')
        return row[row.length - 1];
      }
    },
    pageChanged(page) {
      this.queryParams.page = page;
    },
    deleteRecord(row) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/contents/'+row.id).then(() => {
            this.$swal.fire(
                'Deleted',
                'Contents has been deleted!',
                'success'
            )
            this.loadContents();
          });
        }
      });
    },
    loadContents(){
      this.axios.get('/contents', {params:{...this.queryParams}})
          .then((response) => {
            this.contents = response.data.data
          })
    },
    editContent(row){
      this.resetForm()
      this.deleteFile()
      this.modalForm = row
      this.tempVideo = row.video
      this.newForm = false
      this.showModal = true
      this.dropzonError = ''
      this.isNewVideoUploaded = false

    },
    closeModal(){
      this.showModal = false
      this.errors = null;
      this.dropzonError = ''
      this.tempVideo = ''
    },
    addContent(){
      this.resetForm()
      this.deleteFile()
      this.newForm = true
      this.showModal = true
      this.tempVideo = ''



    },
    onFileChange(event, column){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;

      let file = event.target.files[0]

      this.modalForm[column] = file
    },
    deleteFile(){
      this.modalForm.file = null
      if(this.$refs.imageInput)
        this.$refs.imageInput.value = null
    },
    resetForm(){
      this.modalForm = {
        name: '',
        description: '',
        status: 1,
        page_id: this.$route.params.id,
        file: '',
      }
      this.newForm = false
      this.deleteFile()
    },

    deleteContentFile(id, column){
      let form = {
        id: id,
        column: column
      }

      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.post('/contents-file-delete/', form).then(() => {
            this.$swal.fire(
                'Deleted',
                column+' has been deleted!',
                'success'
            )

            this.modalForm[column] = null;
          });
        }
      });
    },

    async submitContentForm(){
      this.errors = null;
      this.loading = true;
      this.progress = null
      this.isNewVideoUploaded = false

      let formData = new FormData()

      Object.keys(this.modalForm).forEach(key => {
        formData.append(key, this.modalForm[key] ? this.modalForm[key] : '');
      })
      if (this.newForm) {
        await this.axios.post('/contents', formData, {
          onUploadProgress: (progressEvent) => {
            this.progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
            .then(() => {
              this.errors = null;
              this.showModal = false;
              this.loadContents();
              this.deleteFile()
              this.showSuccessMsg("Added Successfully!");
              this.resetForm()
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
              this.progress = null
            })
      } else {
        formData.append('_method','PATCH')
        await this.axios.post('/contents/'+ this.modalForm.id, formData,{
              onUploadProgress: (progressEvent) => {
                this.progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              },
            }
        )
            .then(() => {
              this.errors = null;
              this.showModal = false;
              this.loadContents();
              this.deleteFile()
              this.showSuccessMsg("Updated Successfully!");
              this.resetForm()
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      }

    },
    //content function exit
    //pages function start
    loadPages(){
      this.axios.get('/pages', {params:{page_type:this.$route.params.type}})
          .then((response) => {
            this.pages = response.data.data
          })
    },
    loadCurrentPage(){
      this.axios.get('/pages/'+this.$route.params.id)
          .then((response) => {
            this.form = response.data.data
          })
    },
    submitForm(){
      this.errors = null;
      this.loading = true;
      if(this.$route.name === 'page_edit') {
        this.axios.patch('/pages/'+this.$route.params.id, this.form)
            .then(() => {
              this.$router.push({name: 'pages'})
              this.showSuccessMsg('Page Updated!')
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      } else {
        this.axios.post('/pages', this.form)
            .then(() => {
              this.$router.push({name: 'pages'})
              this.showSuccessMsg('Page Added!')
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      }
    },
    getLabelName(){
      let name = 'Download File'

      if(this.thumbsLabelPages.includes(+this.$route.params.id))
        name = 'Thumb Image';

      return name;
    }
  }
}
</script>
